"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const TeamRemove = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M4.5 24a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM2 20h5v-1H2v1z", clipRule: "evenodd" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M20 7.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM21.735 18h-6.759c.016-.08.024-.163.024-.25v-5.263c0-.498-.11-.96-.304-1.376a4.84 4.84 0 002.54.712A4.837 4.837 0 0019.946 11c1.14.033 2.053.942 2.053 2.058v4.685a.261.261 0 01-.265.257zM13 13.058V18h.714c.158 0 .286-.112.286-.25v-5.263c0-.359-.086-.7-.24-1.008-.465.377-.76.945-.76 1.58z",
        clipRule: "evenodd",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M8 9a3 3 0 100-6 3 3 0 000 6zm3.494 1c-.984.62-2.19.984-3.494.984A6.556 6.556 0 014.506 10C3.094 10.152 2 11.207 2 12.487V14.6A5.502 5.502 0 019.793 18h3.921c.158 0 .286-.112.286-.25v-5.263c0-1.28-1.094-2.335-2.506-2.487z",
        clipRule: "evenodd"
      }
    )
  );
};
export default TeamRemove;
